import { DownloadManagerContext } from "@src/context/DownloadManagerContext";
import { useContext } from "react";

const useDownloadManager = () => {
  const downloadManager = useContext(DownloadManagerContext);

  if (!downloadManager)
    throw new Error("No download manager provider was found");

  return downloadManager;
};

export default useDownloadManager;
